import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { IPicture } from '@finder/shared/components/picture/picture.interface';
import { MOBILE_MEDIA_QUERY } from '@finder/shared/constants/app.constants';
import { PictureComponent } from '../picture/picture.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

const DEFAULT_CSS_CLASS = 'dark';
@Component({
    selector: 'finder-promo-banner',
    templateUrl: './promo-banner.component.html',
    styleUrls: ['./promo-banner.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        PictureComponent,
        SafeHtmlPipe,
    ]
})
export class PromoBannerComponent implements OnInit, OnChanges {
    @Input() promoData;

    images: IPicture;
    hoverImages: IPicture;
    srcGroup: IPicture;
    textClass: string;

    constructor() { }

    ngOnInit() {
        this.setupStyling();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.promoData.firstChange) {
            return;
        }

        this.setupStyling();
    }

    private setupStyling() {
        this.images = {
            desktop: this.promoData.imageDesktop.url,
            media: MOBILE_MEDIA_QUERY,
            mobile: this.promoData.imageMobile.url,
            alt: this.promoData.imageDesktop.alt,
        };
        this.hoverImages = {
            desktop: this.promoData.hoverImageDesktop.url,
            media: MOBILE_MEDIA_QUERY,
            mobile: this.promoData.hoverImageMobile.url,
            alt: this.promoData.hoverImageDesktop.alt,
        };
        this.srcGroup = this.images;
        this.textClass = this.promoData.textColor || DEFAULT_CSS_CLASS;
    }
}
